import React from 'react';

const Separator = ({ text }) => (
  <div className="section-separator">
    <div className="section-separator__text"><h6 className="margin-0 inline">{text}</h6></div>
    <div className="section-separator__line"></div>
  </div>
);

export default Separator;
